
/**
 * Created by Ning Jiang on 11/24/2016.
 */

import { ZeroBetManager } from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetManager";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { BalanceEvent } from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";

export class SanZeroManager extends ZeroBetManager {

    private static nextMode:string = GameMode.NORMAL;

    private static playerChoice:number = -1;
    private static fsLeft:number = -1;

    constructor() {
        super();
    }

    public static setPlayerChoice(value:number):void{
        this.playerChoice = value;
    }

    public static setNextMode(mode:string, fsLeft:number){
        SanZeroManager.nextMode = mode;
        SanZeroManager.fsLeft = fsLeft;
    }

    public tryPlayZeroBet():boolean {
        if(this.isNextZeroBet()) 
            this.playZeroBet();

        return this.isNextZeroBet();
    }

    public isNextZeroBet():boolean {
        return !(SanZeroManager.nextMode === "NORMAL");
    }

    public playZeroBet():void {
        if(SanZeroManager.nextMode == "FREESPIN_PICK")
            EventHandler.dispatchEvent(new GameEvent(BalanceEvent.PICK_AND_CLICK, SanZeroManager.playerChoice));
        else
            EventHandler.dispatchEvent(new GameEvent(BalanceEvent.ZERO_BET, SanZeroManager.fsLeft));
    }
}